module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-4-3fbd302e95390a4d1855e80267c2b16c.svg";